/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { Validators } from '@angular/forms';
import { DMValidators, FormControl, FormGroup, SlideWindowAbstract } from '@dm/core';
import { ToolService } from 'app/common/services';

import { CifsShareService } from '../../../share/cifs-share/cifs-share.service';
import { CifsShareStrService } from '../../../share/cifs-share/cifs-share-str.service';
import { NfsShareService } from '../../../share/nfs-share/nfs-share.service';
import { NfsShareStrService } from '../../../share/nfs-share/nfs-share-str.service';
import { SimpleFileShareModifyShareNameParams } from '../../file-system';
import { FileSystemStrService } from '../../file-system-str.service';

@Component({
    selector: 'app-modify-share-name',
    templateUrl: './modify-share-name.component.html',
    styleUrls: ['./modify-share-name.component.scss'],
})
export class ModifyShareNameComponent extends SlideWindowAbstract implements OnInit {
    @Input() data: SimpleFileShareModifyShareNameParams;
    @Output() update: EventEmitter<SimpleFileShareModifyShareNameParams> = new EventEmitter();

    windowVisible = true;

    vm: FormGroup;
    errorMessage: any;

    defaultDateConfig;

    i18n = this.str.i18n;

    constructor(
        injector: Injector,
        public str: FileSystemStrService,
        private nfsService: NfsShareService,
        private nfsStrService: NfsShareStrService,
        private cifsService: CifsShareService,
        private cifsStrService: CifsShareStrService,
        private toolService: ToolService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.initVm();
    }

    initVm(): void {
        const data = this.data;

        this.vm = new FormGroup({
            nfsShareName: new FormControl(data.nfsShareName, {
                validators: [
                    this.nfsService.nfsShareNameValidator,
                ],
                updateOn: 'blur',
            }),
            cifsShareName: new FormControl(data.cifsShareName, {
                validators: [
                    Validators.required,
                    DMValidators.rangeByteLength(this.cifsStrService.cifsShareNameMinLen,
                        this.cifsStrService.cifsShareNameMaxLen),
                    this.cifsService.cifsShareNameValidator,
                ],
                updateOn: 'blur',
            }),
        });

        this.errorMessage = {
            nfsShareName: {
                nfsShareName: this.nfsStrService.i18n.error.shareName,
            },
            cifsShareName: {
                required: this.toolService.requiredErr(this.i18n.cifsShareNameLab),
                rangeByteLength: this.toolService.rangeByteLengthErr(this.cifsStrService.cifsShareNameMinLen,
                    this.cifsStrService.cifsShareNameMaxLen),
                cifsShareName: this.str.get(this.cifsStrService.i18n.tip.shareNameValidation,
                    [this.i18n.cifsShareNameLab]),
            },
        };

        if (this.data.showNfsShareForm) {
            this.vm.get('nfsShareName').enable();
        } else {
            this.vm.get('nfsShareName').disable();
        }

        if (this.data.cifsShareName) {
            this.vm.get('cifsShareName').enable();
        } else {
            this.vm.get('cifsShareName').disable();
        }
    }

    onOk(): void {
        this.vm.validate((valid) => {
            if (!valid) {
                return;
            }

            this.update.emit({
                nfsShareName: this.vm.value.nfsShareName,
                cifsShareName: this.vm.value.cifsShareName,
            });
            this.hide();
        });
    }
}
